<!-- https://nuxt.com/docs/4.x/directory-structure/app/error -->
<script setup lang="ts">
import InlineSvg from 'vue-inline-svg'
import { type NuxtError, setPageLayout, useRoute } from '#app'
import { defineAsyncComponent } from 'vue'
import { getAppContext } from '@b2ag/micro-front-tools'
import { IdfButton } from '@b2ag/design-system-v2'
const route = useRoute()

const { error } = defineProps({
  error: Object as () => NuxtError,
})

// @ts-expect-error layout value is dynamic but always matches a valid layout key at runtime
setPageLayout(route.meta?.layout || (error?.data as Record<string, unknown>)?.layout || getAppContext().appFrontType)

const MicroFrontNotFoundView = defineAsyncComponent(() => import('@b2ag/micro-front-not-found/view'))

const isNotFound = error?.statusCode === 404
interface ErrorData {
  message?: string
  buttonUrl?: string
  buttonText?: string
  buttonCallback?: () => void
  layout?: string
}
const errorData = (error?.data ?? {}) as ErrorData

const formatStack = (stack: string | undefined): string => {
  if (!stack) return ''
  return stack.replace(/\) at /g, ')\n at ')
}

const title = !isNotFound ? error?.statusMessage || error?.statusCode + '' : undefined
const message = !isNotFound ? errorData?.message || error?.message || error?.statusMessage : undefined
</script>

<template>
  <NuxtLayout>
    <div class="error-page">
      <InlineSvg v-if="!isNotFound" src="/themes/current/images/no_search_result.svg" alt="Error page" />
      <div v-if="!isNotFound">
        <br />
        <h1>{{ title }}</h1>
        <h3>{{ message }}</h3>
        <IdfButton
          v-if="errorData?.buttonUrl || errorData?.buttonText"
          kind="primary"
          tag="a"
          :href="errorData?.buttonUrl || '/'"
          @click="errorData?.buttonCallback ? errorData.buttonCallback() : null"
        >
          {{ errorData?.buttonText || "Retour à l'accueil" }}
        </IdfButton>
      </div>
      <Suspense>
        <MicroFrontNotFoundView v-if="isNotFound" :title="title" :message="message" />
      </Suspense>
    </div>

    
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.error-page {
  text-align: center;
  padding-top: var(--spacing-6);

  a {
    margin-top: var(--spacing-2);
  }

  p {
    margin: auto;
    max-width: 600px;
  }
}

.dev-mode {
  margin-top: var(--spacing-3);
  margin-left: var(--spacing-4);
}

.stack-trace {
  white-space: pre-wrap;
  font-family: monospace;
  text-align: left;
}
</style>
